(function ($, Drupal) {
  Drupal.behaviors.product_finder = {
    attach: function (context, settings) {
      const urlParams = new URLSearchParams(window.location.search);
      let hasProductCategory = false;

      // Count number of td's in the first tr of the table
      let tdCount = $('#comparison-table tbody tr:first td').length;
      if(tdCount < 3) {
        $('#comparison-table').addClass('hide-remove');
      }

      // Check if the current page contains ?emptySession=true
      if (urlParams.has('emptySession')) {
        // Refresh the current page and remove the query params
        window.location.href = window.location.pathname;
      }

      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith("f[")) {
          const decoded = decodeURIComponent(value);
          if (decoded.startsWith("pf_product_category:")) {
            hasProductCategory = true;
            break;
          }
        }
      }

      if (!hasProductCategory) {
        document
          .querySelectorAll(".card__product_finder .add-link")
          .forEach((el) => {
            el.classList.add("disable-link");

            replaceATagWithDiv(el);

            tippy(el, {
              content: Drupal.t("Please select a product category first."),
            });
          });
      }

      $(once("productFinder", ".product-finder--block")).each(function (e) {
        var sidebar = $(this).find(".productfinder__off-canvas");
        $(this)
          .find(".add-productfinder-siderbar")
          .click(function (e) {
            sidebar.addClass("open-productfinder-sidebar");
            $(".page_content").addClass("absolute");
          });

        $(this)
          .find(".remove-productfinder-siderbar")
          .click(function (e) {
            sidebar.removeClass("open-productfinder-sidebar");
            $(".page_content").removeClass("absolute");
          });
      });

      $(once("resetFilters", ".layout--product-finder .reset-filters")).on(
        "click",
        function (e) {
          e.preventDefault();
          window.location.href = window.location.pathname;
        }
      );

      $(
        once(
          "toggles",
          ".layout--product-finder .productfinder__sidebar .block-facet--checkbox, .layout--product-finder .block-facet--searchbox-checkbox"
        )
      ).each(function () {
        const $block = $(this);
        const $content = $block
          .find(
            ".item-list__checkbox, .facets-soft-limit-link, .facet--wrapper"
          )
          .hide();

        $block.find("h3").on("click", function () {
          $content.slideToggle(200, function () {
            $block.toggleClass("active", $content.first().is(":visible"));
          });
        });
      });

      function replaceATagWithDiv(anchorElement) {
        if (!(anchorElement instanceof HTMLAnchorElement)) {
          return;
        }

        const div = document.createElement("div");

        for (let attr of anchorElement.attributes) {
          if (attr.name !== "href") {
            div.setAttribute(attr.name, attr.value);
          }
        }

        div.innerHTML = anchorElement.innerHTML;
        anchorElement.parentNode.replaceChild(div, anchorElement);

        return div;
      }
    },
  };
})(jQuery, Drupal);
